import { useEffect } from "react";

const SITE_URL = "https://parusanakryshe.ru";

interface SeoOptions {
  title: string;
  description: string;
  keywords?: string;
  image?: string;
  canonical?: string;
}

function setMeta(nameOrProp: string, content: string, attr: "name" | "property" = "name") {
  let el = document.querySelector(`meta[${attr}="${nameOrProp}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, nameOrProp);
    document.head.appendChild(el);
  }
  el.content = content;
}

function setLink(rel: string, href: string) {
  let el = document.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement("link");
    el.rel = rel;
    document.head.appendChild(el);
  }
  (el as HTMLLinkElement).href = href;
}

export function useSeo({ title, description, keywords, image, canonical }: SeoOptions) {
  useEffect(() => {
    document.title = title;

    setMeta("description", description);
    setMeta("robots", "index, follow");

    if (keywords) setMeta("keywords", keywords);

    const canonicalUrl = canonical ? `${SITE_URL}${canonical}` : SITE_URL + window.location.pathname;
    setLink("canonical", canonicalUrl);

    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    setMeta("og:type", "website", "property");
    setMeta("og:locale", "ru_RU", "property");
    setMeta("og:site_name", "Паруса на крыше", "property");
    setMeta("og:url", canonicalUrl, "property");

    if (image) {
      const imageUrl = image.startsWith("http") ? image : `${SITE_URL}${image}`;
      setMeta("og:image", imageUrl, "property");
      setMeta("twitter:image", imageUrl);
    }

    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
  }, [title, description, keywords, image, canonical]);
}
